<template>
  <el-container direction="vertical">
    <router-view></router-view>
  </el-container>
</template>

<script>
export default {
  created() {
    this.$router.push('/channel/channelDataloader')
  },
  components: {},
  computed: {}
}
</script>

<style>
</style>